import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useOpenClose } from '@/composables';

interface Props {
  title?: string;
  description?: string;
  width?: string;
  height?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiModal',
  props: {
    title: null,
    description: null,
    width: { default: '700px' },
    height: null
  },
  setup(__props: any, { expose }) {



const { isOpen, open, close } = useOpenClose();

const modal = ref(null);
onClickOutside(modal, () => close());

expose({ isOpen, open, close });

return { __sfc: true,isOpen, open, close, modal }
}

})